<template>
  <div class="main">
    <h1>Terms of Use</h1>
    <p>
      Welcome to Travvir! These Terms of Use ("Terms") govern your use of our
      services. By using our website, mobile application, or any other services
      provided by Travvir (collectively, the "Services"), you agree to these
      Terms. Please read them carefully.
    </p>
    <div class="content">
      <div class="content_info">
        <b class="heading">1. Introduction</b>
        <div class="info">
          <p>
            1.1 These Terms set out the conditions on which we offer our
            Services to you.
          </p>
          <p>
            1.2 By accessing or using our Services, you agree to be bound by
            these Terms and our Privacy Policy.
          </p>
          <p>
            1.3 If you do not agree to these Terms, you may not use our
            Services.
          </p>
        </div>
        <b class="heading"> 2. Eligibility </b>
        <div class="info">
          <p>
            2.1 You must be at least 13 years of age to use our Services. By
            using our Services, you represent and warrant that you are at least
            13 years old.
          </p>
          <p>
            2.2 If you are under the age of 18, you may use the Services only
            with the involvement of a parent or guardian who agrees to be bound
            by these Terms.
          </p>
          <p>
            2.3 You agree to provide accurate, current, and complete information
            during the registration process and to update such information to
            keep it accurate, current, and complete.
          </p>
        </div>
        <b class="heading">3. Use of Services</b>
        <div class="info">
          <p>
            3.1 You agree to use the Services only for lawful purposes and in
            accordance with these Terms.
          </p>
          <p>3.2 You agree not to: -</p>
          <ul>
            <li>Violate any applicable laws or regulations.</li>
            <li>
              Post, upload, or transmit any content that is illegal, harmful, or
              otherwise objectionable.
            </li>
            <li>
              Impersonate any person or entity or misrepresent your affiliation
              with any person or entity.
            </li>
            <li>
              Engage in any activity that interferes with or disrupts the
              Services or the servers and networks connected to the Services.
            </li>
            <li>
              Use any automated system or software to extract data from our
              Services for commercial purposes without prior consent.
            </li>
          </ul>
        </div>
        <b class="heading">4. User Content</b>
        <div class="info">
          <p>
            4.1 You are solely responsible for any content that you post,
            upload, or transmit via the Services.
          </p>
          <p>
            4.2 By submitting content to Travvir, you grant us a worldwide,
            non-exclusive, royalty-free, perpetual, irrevocable, and
            sub-licensable right to use, reproduce, modify, adapt, publish,
            translate, create derivative works from, distribute, perform, and
            display such content in any media.
          </p>
          <p>
            4.3 You represent and warrant that you have the right to grant these
            rights to Travvir and that such content does not infringe any
            third-party rights.
          </p>
        </div>
        <b>5. Intellectual Property</b>
        <div class="info">
          <p>
            5.1 All content, software, and technology used in connection with
            the Services are the property of Travvir or its customers/clients
            and are protected by copyright, trademark, patent, and other
            intellectual property laws.
          </p>
          <p>
            5.2 You agree not to modify, reproduce, distribute, create
            derivative works of, publicly display, or in any way exploit any of
            the content, software, or technology except as expressly authorized
            by Travvir.
          </p>
        </div>
        <b class="heading">6. Third-Party Links</b>
        <div class="info">
          <p>
            6.1 Our Services may contain links to third-party websites or
            resources.
          </p>
          <p>
            6.2 Travvir is not responsible for the content, products, or
            services on or available from those websites or resources, or links
            displayed on such sites.
          </p>
          <p>
            6.3 You acknowledge sole responsibility for and assume all risk
            arising from your use of any third-party websites or resources.
          </p>
        </div>
        <b class="heading">7. Disclaimers and Limitation of Liability</b>
        <div class="info">
          <p>
            7.1 The Services are provided "as is" and "as available" without
            warranties of any kind, either express or implied.
          </p>
          <p>
            7.2 Travvir disclaims all warranties, express or implied, including,
            without limitation, implied warranties of merchantability, fitness
            for a particular purpose, title, and non-infringement.
          </p>
          <p>
            7.3 In no event shall Travvir be liable for any indirect,
            incidental, special, consequential, or punitive damages, or any loss
            of profits or revenues, whether incurred directly or indirectly, or
            any loss of data, use, goodwill, or other intangible losses,
            resulting from:
          </p>
          <ul>
            <li>Your use or inability to use the Services.</li>
            <li>
              Any unauthorized access to or use of our servers and/or any
              personal information stored therein.
            </li>
            <li>
              Any interruption or cessation of transmission to or from the
              Services.
            </li>
            <li>
              Any bugs, viruses, trojan horses, or the like that may be
              transmitted to or through the Services by any third party.
            </li>
            <li>
              - Any errors or omissions in any content or for any loss or damage
              incurred as a result of the use of any content posted, emailed,
              transmitted, or otherwise made available through the Services.
            </li>
          </ul>
        </div>
        <b class="heading"> 8. Indemnification </b>
        <div class="info">
          <p>
            8.1 You agree to indemnify, defend, and hold harmless Travvir, its
            affiliates, officers, directors, employees, agents, and licensors
            from and against any claims, liabilities, damages, losses, and
            expenses, including, without limitation, reasonable legal and
            accounting fees, arising out of or in any way connected with your
            access to or use of the Services or your violation of these Terms.
          </p>
        </div>
        <b class="heading">9. Termination</b>
        <div class="info">
          <p>
            9.1 Travvir reserves the right to terminate or suspend your access
            to all or part of the Services at any time, with or without cause,
            with or without notice, effective immediately.
          </p>
        </div>
        <b class="heading">10. Governing Law</b>
        <div class="info">
          <p>
            10.1 These Terms and your use of the Services will be governed by
            and construed in accordance with the laws of India, without regard
            to its conflict of laws principles.
          </p>
          <p>
            10.2 You agree to submit to the personal and exclusive jurisdiction
            of the courts located in India for the resolution of any disputes
            arising out of or relating to these Terms or your use of the
            Services.
          </p>
        </div>
        <b class="heading"> 11. Miscellaneous</b>
        <div class="info">
          <p>
            11.1 If any provision of these Terms is found to be invalid or
            unenforceable, the remaining provisions will continue to be valid
            and enforceable.
          </p>
          <p>
            11.2 The failure of Travvir to enforce any right or provision of
            these Terms will not be deemed a waiver of such right or provision.
          </p>
          <p>
            11.3 These Terms constitute the entire agreement between you and
            Travvir regarding your use of the Services and supersede any prior
            agreements between you and Travvir.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
$font-size: 16px;
$line-height: 110%;
.main {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.8);
  height: fit-content;
  font-family: Manrope;
  max-height: 100%;
  padding: 5rem 0.5rem;
  h1 {
    font-size: 50px;
    line-height: 110%;
    font-weight: 700;
    letter-spacing: -0.02em;
    text-align: start;
    @include respond-below(sm) {
      font-size: 30px;
    }
  }
  p {
    margin-top: 1rem;
    font-size: 25px;
    line-height: 120%;
    font-family: Manrope;
    font-weight: 400;
    letter-spacing: -0.02em;
    text-align: start;
    @include respond-below(sm) {
      font-size: 16px;
    }
  }
  .content {
    margin: 4rem 0rem;
    @include respond-below(sm) {
      margin-top: 1rem;
    }
    &_info {
      b {
        font-size: 26px;
        @include respond-below(sm) {
          font-size: 20px;
        }
      }
      .info {
        padding: 2rem 0rem 2rem 1rem;
        @include respond-below(sm) {
          padding: 1rem 0.5rem 1rem 0.5rem;
        }
        p {
          font-size: 22px;
          @include respond-below(sm) {
            font-size: 16px;
          }
        }
        ul {
          margin: 0.5rem 0rem 0.2rem 2.2rem;
          li {
            font-size: 18px;
            margin: 0.1rem 0rem;
          }
        }
      }
    }
  }
}
</style>
